import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

const FloatingPortalContext = createContext<HTMLElement | null>(null);

/** Keep floating controls inside the modal that owns their trigger. */
export function FloatingPortalProvider({
  container,
  children,
}: {
  container: HTMLElement | null;
  children: ReactNode;
}) {
  return (
    <FloatingPortalContext.Provider value={container}>
      {children}
    </FloatingPortalContext.Provider>
  );
}

export const useFloatingPortalContainer = () =>
  useContext(FloatingPortalContext);
